export const COURSE_THUMBNAIL_ASPECT = 16 / 9;
export const COURSE_THUMBNAIL_WIDTH = 1280;
export const COURSE_THUMBNAIL_HEIGHT = 720;

export const isImageFile = (file) => file?.type?.startsWith('image/');

export const getCroppedThumbnailFile = (cropper, originalFileName = 'thumbnail') => {
  if (!cropper) return Promise.resolve(null);

  const canvas = cropper.getCroppedCanvas({
    width: COURSE_THUMBNAIL_WIDTH,
    height: COURSE_THUMBNAIL_HEIGHT,
    imageSmoothingEnabled: true,
    imageSmoothingQuality: 'high',
  });

  if (!canvas) return Promise.resolve(null);

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          resolve(null);
          return;
        }
        const baseName = String(originalFileName || 'thumbnail').replace(/\.[^.]+$/, '');
        resolve(new File([blob], `${baseName}_thumbnail.jpg`, { type: 'image/jpeg' }));
      },
      'image/jpeg',
      0.92
    );
  });
};
